window.addEventListener("xtra__updated-predictive-search-results", () => {
  const listItems = document.querySelectorAll(".search-result-list__item");

  listItems.forEach((listItem) => {
    const productHandle = listItem
      .querySelector("[data-product-handle]")
      ?.getAttribute("data-product-handle");

    fetch(
      `${window.Shopify.routes.root}products/${productHandle}?view=metafields`,
    )
      .then((res) => res.text())
      .then(JSON.parse)
      .then((data) => {
        const { available_in_b2b, available_in_b2c } = data;

        if (available_in_b2b !== available_in_b2c) {
          // one or the other is not available
          if (available_in_b2b) {
            listItem.querySelectorAll("[href]").forEach((elem) => {
              elem.href = elem.href + "&view=b2b";
            });
          } else {
            // default is b2c view, all ok
          }
        } else {
          if (available_in_b2b) {
            // available in both, show the contract button
            const contractBtn = document.createElement("a");
            contractBtn.href = `/products/${productHandle}?view=b2b`;
            contractBtn.classList.add("xtra--product-b2b-link");
            contractBtn.innerText = "Contract";

            listItem.querySelector("h3.wt-cart__item__name").after(contractBtn);
          } else {
            // hide this result as it's not available for both b2b and b2c
            listItem.style.display = "none";
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  });
});
